<template>
	<transition name="modal" @keyup.esc.stop="showModal = false">
		<div class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Novo atendimento de procedimento</h3>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-6">
							<div :class="{'form-group': true, 'has-error':errors.has('profissional') }">
								<label>Profissional</label>
								<select-profissional v-if="!dados.exibiInput" name="profissional" placeholder="PROFISSIONAL" @setProfissionalSelecionado="(profissionalSelecionado)=>{setProfissionalSelecionado(profissionalSelecionado)}" v-validate="'required'"></select-profissional>
								<input class="form-control" disabled="true" type="text" :value="dados.nome_profissional" v-if="dados.exibiInput"  v-validate="'required'"  >
								<span v-show="errors.has('profissional')" class="help-block">{{ errors.first('profissional') }}</span>
							</div>
						</div>
						<div class="col-md-6">
							<div :class="{'form-group': true, 'has-error':errors.has('procedimento') }">
								<label>Procedimento</label>
								<select-procedimento-contrato v-if="!dados.exibiInput" name="procedimento" :semAgrupados="1" :contrato-id="$route.params.distribuicaoContratoId" placeholder="PROCEDIMENTO" @setProcedimentoSelecionado="(procedimentoSelecionado)=>{setProcedimentoSelecionado(procedimentoSelecionado)}" v-validate="'required'"></select-procedimento-contrato>
								<input class="form-control" disabled="true" type="text" :value="dados.nome_procedimento" v-if="dados.exibiInput"  v-validate="'required'"  >
								<span v-show="errors.has('procedimento')" class="help-block">{{ errors.first('procedimento') }}</span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<label>Sexo</label>
								<select class="form-control" v-model="dados.sexo">
										<option value="0">Ambos</option>
										<option value="1">Masculino</option>
										<option value="2">Feminino</option>
									</select>
							</div>
						</div>
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('idade_minima') }">
								<label>Idade mínima</label>
								<input type="number" min="0" class="form-control" v-model="dados.idade_minima" v-validate="(dados.idade_maxima ? 'required|max_value:' + dados.idade_maxima : '')" name="idade_minima" ref="idade_minima">
								<span v-show="errors.has('idade_minima')"  class="help-block">Deve ser menor que a idade máxima</span>
							</div>
						</div>
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('idade_maxima') }">
								<label>Idade máxima</label>
								<input type="number" max="110" class="form-control" v-model="dados.idade_maxima" v-validate=" (dados.idade_minima ? 'required|min_value:' + dados.idade_minima : '')" name="idade_maxima" ref="idade_maxima">
								<span v-show="errors.has('idade_maxima')" class="help-block">Deve ser maior que a idade mínima</span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('atendimento') }">
								<label>Atendimentos</label>
								<input type="number" class="form-control" v-model="dados.quantidade_primeira" v-validate="(dados.quantidade_retorno === '') && (dados.quantidade_local === '') ?'required' : ''" name="atendimento" ref="atendimento">
								<span v-show="errors.has('atendimento')" class="help-block">Defina ao menos uma vaga</span>
							</div>
						</div>
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('retorno') }">
								<label>Retorno</label>
								<input type="number" class="form-control" v-model="dados.quantidade_retorno" v-validate="(dados.quantidade_primeira === '') && (dados.quantidade_local === '') ?'required' : ''" name="retorno" ref="retorno">
								<span v-show="errors.has('retorno')" class="help-block">Defina ao menos uma vaga</span>
							</div>
						</div>
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('local') }">
								<label>Local</label>
								<input type="number" class="form-control" v-model="dados.quantidade_local" v-validate="(dados.quantidade_primeira === '') && (dados.quantidade_retorno === '') ?'required' : ''" name="local" ref="local">
								<span v-show="errors.has('local')" class="help-block">Defina ao menos uma vaga</span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('data') }">
								<label for="">Data: </label>
								<input v-model="dados.data_atendimento" class="form-control" type="date" placeholder="DATA" v-validate="'required'" name="data" ref="data">
								<span v-show="errors.has('data')" class="help-block">{{ errors.first('data') }}</span>
							</div>
						</div>
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('hora_inicial') }">
								<label>Hora inicial</label>
								<input type="time" class="form-control" v-model="dados.hora_inicial" v-validate="'required'" name="hora_inicial" ref="hora_inicial">
								<span v-show="errors.has('hora_inicial')" class="help-block">{{ errors.first('hora_inicial') }}</span>
							</div>
						</div>
						<div class="col-md-4">
							<div :class="{'form-group': true, 'has-error':errors.has('hora_final') }">
								<label>Hora final</label>
								<input type="time" class="form-control" v-model="dados.hora_final" v-validate="'required'" name="hora_final" ref="hora_final">
								<span v-show="errors.has('hora_final')" class="help-block">{{ errors.first('hora_final') }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="row">
						<div class="col-md-12">
							<button @click="salvar()" class="btn btn-primary pull-right" type="button"><i class="fa fa-save"></i> Salvar</button>
							<button tag="a" @click="$emit('close')" class="btn btn-default pull-left"><i class="fa fa-close"></i> Cancelar</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import axios from 'axios' // Cliente para requisição http
import selectProfissional from "../../cadastros/profissionais/selectProfissional";
import selectProcedimentoContrato from "../contratos/selectDistribuicaoProcedimentosContrato";

export default {
	filters: {},
	props: ["show", "item"],
	data: () => ({
		dados: {
			profissional_id: '',
			nome_profissional: '',
			distribuicao_contrato_procedimento_id: '',
			nome_procedimento: '',
			sexo: 0,
			idade_maxima: '',
			idade_minima: '',
			quantidade_primeira: '',
			quantidade_retorno: '',
			quantidade_local: '',
			hora_inicial: '',
			hora_final: '',
			data_atendimento: '',
			exibiInput : false
		},
	}),
	mounted() {

		document.body.addEventListener('keyup', e => {
			if (e.keyCode === 27) {
				e.stopPropagation()
				this.$emit('close');
			}

		});

	},
	methods: {
		setProcedimentoSelecionado(procedimentoSelecionado) {
			this.dados.nome_procedimento = procedimentoSelecionado.procedimento.nome;
			this.dados.distribuicao_contrato_procedimento_id = procedimentoSelecionado.id;
		},
		setProfissionalSelecionado(profissionalSelecionado) {
			this.dados.nome_profissional = profissionalSelecionado.nome;
			this.dados.profissional_id = profissionalSelecionado.id;
		},
		salvar() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.$store.commit('TOGGLE_LOADING');
					axios
						.post(
							`${this.$store.state.serverURI}/api/distribuicao/agenda/createProcedimentoAtendimento`, this.dados,
							this.$store.getters.getHeaderAuth
						)
						.then(response => {
							this.$store.commit('TOGGLE_LOADING');
							this.$swal({
								type: "success",
								title: "Atendimento criado com sucesso!",
								showConfirmButton: false,
								timer: 1500
							});
							// this.dados = {}
							this.$emit('atualizar');
							this.$emit('close');
						})
						.catch(error => {
							this.$store.commit('TOGGLE_LOADING');
							var erros = error.response.data.message + " ";
							for (var erro of Object.values(error.response.data.errors)) {
								erros += erro + " \n";
							}
							this.$swal({
								type: "error",
								title: "Houve uma falha!",
								text: erros
							});
						});
				}
			})
		},
		isEmpty(valor) {
			return valor === '';
		},
		hasDay() {
			return false;
		}
	},
	watch: {
		item: {

			immediate: true,
			handler (value) {

				this.dados.exibiInput = false
				this.dados.idade_minima = ''
				this.dados.idade_maxima = ''
				this.dados.sexo = ''

				this.dados.nome_procedimento = ''
				this.dados.distribuicao_contrato_procedimento_id = ''

				this.dados.nome_profissional = ''
				this.dados.profissional_id = ''
				console.log(value)
				if (value.profissional && value.contrato_procedimento) {
					this.dados.exibiInput = value.autoChange
					this.dados.idade_minima = value.idade_minima
					this.dados.idade_maxima = value.idade_maxima
					this.dados.sexo = value.sexo

					this.dados.nome_procedimento = value.contrato_procedimento.procedimento.nome
					this.dados.distribuicao_contrato_procedimento_id = value.distribuicao_contrato_procedimento_id

					this.dados.nome_profissional = value.profissional.nome;
					this.dados.profissional_id = value.profissional.id;

				}
			}
		},

	},
	components: {
		selectProfissional,
		selectProcedimentoContrato,
	},
}
</script>

<style scoped>
* {
	box-sizing: border-box;
}

.v-select .dropdown-toggle {
	padding: 0 !important;
	border-radius: 0px !important;
}

.v-select input[type=search] {
	margin: 0 0 0 !important;
}

.v-select .selected-tag {
	margin: 5px !important;
}
</style>



// WEBPACK FOOTER //
// criarAtendimentoModal.vue?488cca1d